module.exports = __webpack_public_path__ + "static/media/sample-activity-image.558fb268.webp";